import { CircularProgress, IconButton,  Stack, TextField } from "@mui/material";
import { SyntheticEvent, useContext, useState } from "react";
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { CardSwapUpdateDto } from "../dtos/CardSwapUpdateDto";
import { CardSwapStatusCode } from "../enums/CardSwapStatusCode";
import VspPortalContext from "../../../store/VspPortalContext";
import { useCardSwapHttp } from "../hooks/useCardSwapHttp";

type EnterNewCardNumberProps = { 

    cardSwapSearchResultId: number;
    onClose: ( isUpdated : boolean ) => void;

};


const inlineInputSx = {
    
    '.MuiInputBase-root': {

        paddingTop: '10px'
    }

};


export const EnterNewCardNumber : React.FC< EnterNewCardNumberProps > = ( props : EnterNewCardNumberProps) => {

    const { cardSwapSearchResultId, onClose } = props;

    const [ cardNumber, setCardNumber ] = useState< string >( '' );
    const [ isCardNumberValid, setIsCardNumberValid ] = useState< boolean >( false );
    const [ isUpdating, setIsUpdating ] = useState< boolean >( false );

    
    const { state } = useContext( VspPortalContext );


    const { updateCardSwap } = useCardSwapHttp( );


    const handleCloseClick = ( event : SyntheticEvent ) => { 
        
        event.stopPropagation( );
        onClose( false );
        
    };
    

    const handleCardNumberChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {

        const value = event.target.value;
        setCardNumber( value );
        checkCardNumberValidity( value );

    };

    const handleCardNumberKeyUp = ( event: React.KeyboardEvent<HTMLDivElement> ) => {

        if( event.key === 'Escape' ) {

            onClose( false );

        }
        
        if( event.key !== 'Enter' || !isCardNumberValid ) {
            
            return;

        }

        update( );

    };

    const handleOkClick = ( event : SyntheticEvent ) => {

        event.stopPropagation( );

        if( !isCardNumberValid ) {
            
            return;

        }

        update( );

    };


    const checkCardNumberValidity = ( cardNumber : string ) => {

        const containsNumbersOnly = /^\d+$/.test( cardNumber );

        if( containsNumbersOnly && cardNumber.length >= 6 && cardNumber.length <= 8 ){

            setIsCardNumberValid( true );

        } else {

            setIsCardNumberValid( false );

        }

    };


    const update = async( ) => {

        const cardSwapUpdateDto : CardSwapUpdateDto = {

            cardSwapStatusCode : CardSwapStatusCode.NewCardCreated,
            id : cardSwapSearchResultId,
            newCardNumber : cardNumber,
            updatedBy : state.username

        };

        setIsUpdating( true );
        const isSuccess = await updateCardSwap( cardSwapUpdateDto ); 
        setIsUpdating( false );


        if( isSuccess ){
            
            onClose( true );

        }

    };

    return(
        <>

            <Stack direction="row" display="flex">
                <TextField 
                    autoFocus
                    disabled={ isUpdating }
                    InputProps={{
                        disableUnderline: true
                    }}
                    onChange={ handleCardNumberChange }
                    onKeyUp={ handleCardNumberKeyUp }
                    placeholder="Card Number"
                    sx={ inlineInputSx }
                    value={ cardNumber }
                    variant="standard"
                />
                
                {
                    isUpdating
                        ?
                    <CircularProgress size="20px" sx={{ display: 'flex', marginTop: '10px', color: '#e65400'}}  />
                        :
                    <Stack direction="column">
                        <IconButton 
                            sx={{ color: 'green', height: '25px', width: '25px' }}
                            disabled={ !isCardNumberValid || isUpdating }
                            onClick={ e => handleOkClick( e ) }
                        >
                            <DoneIcon sx={{ height: '20px', width: '20px' }}/>
                        </IconButton>
                        <IconButton 
                            disabled={ isUpdating }
                            sx={{ color: 'red', height: '25px', width: '25px' }}
                            onClick={ e => handleCloseClick( e ) }
                        >
                            <ClearIcon sx={{ height: '20px', width: '20px' }}/>
                        </IconButton>
                    </Stack>

                }

            </Stack>

        </>
    );


};
